import { getPerformanceRoute } from './performanceRoute';

// OAuth codes and password-reset tokens must never enter analytics payloads.
export const sanitizeTelemetryEvent = (event) => {
  try {
    const url = new URL(event.url);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    const pathname = url.pathname.replace(/\/+$/, '') || '/';
    if (pathname.startsWith('/auth/') || pathname.startsWith('/reset-password/')) return null;
    url.pathname = getPerformanceRoute(pathname);
    url.search = '';
    url.hash = '';
    url.username = '';
    url.password = '';
    return { ...event, url: url.toString() };
  } catch {
    return null;
  }
};
